import { useParams } from "react-router-dom";
import { Users } from "lucide-react";
import { SidebarLayout } from "src/layout/SidebarLayout/SidebarLayout";

export const CustomersSection = () => {
  const { projectId } = useParams();

  return (
    <SidebarLayout.SidebarMainLayout.ListNavLink
      to={`/projects/${projectId}/customers`}
      label="Customers"
      iconSvg={<Users size={20} />}
    />
  );
};
